import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";



export const fetchDevices = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.homeUrl}/api/device/list`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return data;
}

export const fetchToggleRelay = async (deviceId: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(
        `${config.homeUrl}/api/relay/toggle/` + deviceId,
        // `${config.homeUrl}/api/relay/toggle/dsdff`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: null
        }
    );
    return data;
}

export const fetchDeviceStatus = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(
        `${config.homeUrl}/api/device/status`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false,
        false
    );
    return data;
}
